export const AUTH_CONFIG = {
  MEDIA_UPLOAD_URL: "https://campaign.vocallabs.ai/upload",
};
